/*
 * app-config
 */
import type { AppConfig } from "@psychology/types"
import { getEnvDomainName, AppTitle } from "@psychology/utils"

export const appConfig: AppConfig = {
	brand: {
		title: AppTitle,
		domain: getEnvDomainName("https://psychology.timeprox.com"),
		themeColor: "#336699",
		supportEmail: "support@psychology.timeprox.com",
		redirectLandingToWaitList: true,
		allowRegistration: false,
	},
	locale: {
		prefix: "always" as const,
		default: "en-US",
		supported: ["en-US", "fr-CA"],
	},
	misc: {
		toastErrorTimeout: 5000,
	},
	redirects: {
		afterSignInUrl: "/dashboard",
		afterSignUpUrl: "/waitlist",
		afterSignOutUrl: "/",
	},
	tools: {
		assetGenerator: {
			iconFolderPath: "public/logo.svg",
			options: {
				faviconStyle: "transparent",
				scaleSvg: 1.4,
				scaleIcon: 0.8,
			},
		},
	},
}
